import { useCallback, useLayoutEffect, useState } from "react";

const QuestionPreview: React.FC<{
  children: React.ReactNode;
  PreviewComponent?: React.FC<{ onClosePreview: () => void }>;
  disablePreview?: boolean;
}> = ({ children, PreviewComponent, disablePreview }) => {
  const hasPreviewComponent = !!PreviewComponent;
  const [isShowingPreview, setIsShowingPreview] = useState(hasPreviewComponent);

  const handlePreview = useCallback((value: boolean) => {
    setIsShowingPreview(() => value);

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useLayoutEffect(
    () => handlePreview(hasPreviewComponent),
    [hasPreviewComponent]
  );

  if (isShowingPreview && hasPreviewComponent && !disablePreview) {
    return (
      <div className="flex flex-1 items-center justify-center bg-white z-50 p-6 text-3xl sm:px-40 min-h-[550px]">
        <div className="sm:w-618">
          <PreviewComponent onClosePreview={() => handlePreview(false)} />
        </div>
      </div>
    );
  }

  return children;
};

export { QuestionPreview };
